import React from 'react'
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import './index.css'
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/router.tsx";
import { Provider } from "react-redux";
import { store } from "./redux/store.ts";
import { Toaster } from "react-hot-toast";
import { ConfirmDialogProvider } from "./components/ui/confirm-dialog";
import { initSentry } from "./lib/sentry.ts";

initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex h-screen flex-col items-center justify-center gap-2 p-6 text-center">
          <h1 className="text-lg font-semibold">Une erreur est survenue</h1>
          <p className="text-sm text-muted-foreground">
            Veuillez rafraîchir la page. Si le problème persiste, contactez le support.
          </p>
        </div>
      }
    >
      <Provider store={store}>
        <ConfirmDialogProvider>
          <RouterProvider router={router} />
        </ConfirmDialogProvider>
        <Toaster position="bottom-right" />
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
